import { Injectable } from '@angular/core';

import { DataManager } from "techlify-ng";

/**
 * Service that provides Place Of Employment Data
 * 
 * @author Floyd Kissoon
 * @since 20180703
 */
@Injectable()
export class OrganizationDataService
{

    private data: any;

    constructor(private dataManager: DataManager)
    {

    }

    getOrganizations()
    {
        var promise;
        if(undefined !== this.data)
        {
            promise = new Promise((resolve, reject) =>
            {
                resolve(this.data);
            });

            return promise;
        }

        promise = this.dataManager.GET("api/organization", { sort_by: "name|ASC" });

        promise.then(
            res =>
            {
                this.data = res;
            }
        );

        return promise;
    }
        
    reloadData()
    {
        this.data = undefined;
        return this.getOrganizations();
    }
}